import React, { useEffect } from 'react';
import { Line } from 'react-chartjs-2'


const LineChart = (props) => {

    // let labelMeses = [];
    let montoMeses = props.data;
    let impuestoMeses = props.impuestos;

    useEffect(() => {
        // meses.map(mes => {
        //     labelMeses.push(mes.display);
        // })
    }, [props.data])

    return (
        <>

            <Line
                data={{

                    // labels: [],
                    datasets: [
                        {
                            label: 'Ventas',
                            data: montoMeses,
                            backgroundColor: [
                                'rgba(255, 206, 86, 0.2)',
                                'rgba(75, 192, 192, 0.2)',
                                'rgba(153, 102, 255, 0.2)',
                                'rgba(255, 159, 64, 0.2)',
                            ],
                            borderColor: [
                                'rgba(255, 206, 86, 1)',
                                'rgba(75, 192, 192, 1)',
                                'rgba(153, 102, 255, 1)',
                                'rgba(255, 159, 64, 1)',
                            ],
                            borderWidth: 2,
                        },
                        {
                            label: 'IVA',
                            data: impuestoMeses,
                            backgroundColor: [
                                'rgba(255, 206, 86, 0.2)',
                                'rgba(75, 192, 192, 0.2)',
                                'rgba(153, 102, 255, 0.2)',
                                'rgba(255, 159, 64, 0.2)',
                            ],
                            borderColor: [
                                'rgba(255, 206, 86, 1)',
                                'rgba(75, 192, 192, 1)',
                                'rgba(153, 102, 255, 1)',
                                'rgba(255, 159, 64, 1)',
                            ],
                            borderWidth: 2,
                        }
                    ],
                }}
                height={400}
                width={600}
                options={{
                    maintainAspectRatio: false,
                }}
            />

        </>
    )

}

export default (LineChart);